/* eslint-disable */
import React, { Component } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { requestTranslation } from '@futures-platform/i18n'
import { PUBLIC_URL } from '../env'
import LinkIcon from '@material-ui/icons/Link';
class ShareRadarModal extends Component {
  // handleClipboardClick = () => this.shareInput.focus()

  render() {
    const {
      requestClose,
      requestOpenPublicLink,
      checkPublicLinkExsited,
      publicLink,
      changeRadarSharing,
      changeRadarSharingExpiry,
      publicShareUrlEnabled,
      urlLoginLink,
      urlLoginExpire,
      updateRadar,
      group,
      id,
      isPublicShareUrlEnabled,
      radarSettings
    } = this.props

    const onClickOpenPublicLink = () => {
      requestOpenPublicLink()
    }

    let isRolesToShowPublicSharedLink = false
    const thisGroup = !!this.props.radarSettings?.group?.id && !!this.props.radarSettings?.groups?.length &&
      this.props.radarSettings?.groups?.filter( gr => {
        if (String(gr?.id) === String(this.props.radarSettings?.group?.id)) return gr
      })
    if (!!thisGroup?.length) {
      const fpRoles = thisGroup[0]?.accountDrupalRoles[0]
      isRolesToShowPublicSharedLink = fpRoles?.some(r => r === "administrator" || r === 'csm')
    }
    else if (!!this.props.radarSettings?.account?.drupal_roles
      && !!this.props.radarSettings?.account?.drupal_roles?.length
      && !!this.props.radarSettings?.account?.drupal_roles[0]?.length) {
          const a = this.props.radarSettings?.account?.drupal_roles[0]
          isRolesToShowPublicSharedLink = a?.some(r => r === "administrator" || r === 'csm')
      }

    return (
      <div>
        <button onClick={requestClose} className='btn-close-modal'>
            <i className='material-icons'>close</i>
        </button>
        <div className={'modal-form-sections'}style={{background: '#fff'}}>
            <div className='modal-form-section modal-form-header'>
                <h2 className={'confirmation-modal-title'}>{requestTranslation('shareRadar')}</h2>
                <p className='mt-4'>
                  {(!!isPublicShareUrlEnabled && !!isRolesToShowPublicSharedLink) ? requestTranslation('shareRadarFromUsrMngmt'): requestTranslation('shareRadarWithoutPublicLink')}
                </p>
                {checkPublicLinkExsited 
                  && publicLink 
                  && (!!isPublicShareUrlEnabled && !!isRolesToShowPublicSharedLink) 
                  && 
                    <div className='mt-4' style={{display: 'flex'}}>
                      <LinkIcon style={{transform: 'rotate(310deg)', borderRadius: '20px'}}>
                      </LinkIcon>
                      <p style={{ paddingLeft:'8px'}}>{requestTranslation('checkPublicLinkAlreadyExisted')}
                      </p>
                    </div>}
            </div>
            <div className='modal-form-section justify-content-end d-flex'>
                <button
                  onClick={requestClose}
                  className='btn btn-lg btn-plain-gray'
                >
                    {requestTranslation('cancel')}
                </button>
                {(!!isPublicShareUrlEnabled && !!isRolesToShowPublicSharedLink) &&
                <div style={{ marginRight: "20px" }}>
                  <a
                    onClick={() => onClickOpenPublicLink()}
                    className="btn btn-lg btn-primary"
                  >
                    {checkPublicLinkExsited && publicLink ? requestTranslation("openPublicLink") : requestTranslation("createPublicLink")} 
                  </a>
                </div>
                }
                <a
                    href={`${PUBLIC_URL}/radarusers?gid=${group.id}&invite=${id}`}
                    className='btn btn-lg btn-primary'
                >
                    {requestTranslation('goToManagement')}
                </a>
            </div>
        </div>
      </div>
    )
  }
}

export default ShareRadarModal
